import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidemenuComponent } from '@components/sidemenu/sidemenu.component';
import {RouterOutlet} from '@angular/router';
import {LoaderComponent} from '@components/loader/loader.component';
import {ModalComponent} from '@components/modal/modal.component';


@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, SidemenuComponent, RouterOutlet, LoaderComponent, ModalComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent  {
  constructor() {}

  menuOpen = signal(false);


  toggleMenu() {
    this.menuOpen.update(v => !v);
  }
}
